import { initialState } from './selectors';

export default (state = initialState) => {
  return state;
};
